module.exports = __webpack_public_path__ + "static/depo-luciana-rosto-007a806047f6ee7f412fe45c97bc4a25.png";